import React from 'react'

function Dashboard ({ className, fill }) {
  return (
    <svg fill={fill} className={className} viewBox='0 0 24 24'>
      <rect width='6' height='6' rx='3' transform='translate(0 0)' />
      <rect width='6' height='6' rx='3' transform='translate(0 9)' />
      <rect width='6' height='6' rx='3' transform='translate(0 18)' />
      <rect width='6' height='6' rx='3' transform='translate(9 0)' />
      <rect width='6' height='6' rx='3' transform='translate(9 9)' />
      <rect width='6' height='6' rx='3' transform='translate(9 18)' />
      <rect width='6' height='6' rx='3' transform='translate(18 0)' />
      <rect width='6' height='6' rx='3' transform='translate(18 9)' />
      <rect width='6' height='6' rx='3' transform='translate(18 18)' />
    </svg>
  )
}

Dashboard.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Dashboard
